/**
 * Reidratação dos campos do cadastro quando o paciente volta um passo.
 *
 * Decisão do stakeholder (29/09/2026): e-mail, CPF e telefone nasciam vazios
 * por desenho, então voltar no meio do funil obrigava a redigitar tudo o que já
 * tinha sido informado.
 *
 * Só volta ao campo o valor que ESTA aba digitou, e a marca é o que prova
 * isso. A presença do dado no `sessionStorage` não serve como prova: o boot do
 * app restaura identidade de cookie e IndexedDB (`restoreIdentityFromBackups`),
 * que são do aparelho e não da aba, e reescreve LS **e** SS. Sem a marca, uma
 * consulta nova em aparelho compartilhado exibiria o CPF de quem usou antes já
 * preenchido, mesmo depois de `ensureSignupSession({ resetFields: true })` ter
 * limpado LS e SS.
 *
 * A marca também é indiferente à forma de voltar — botão Voltar do app, botão
 * do navegador ou gesto de swipe no iOS.
 */

const MARK_PREFIX = 'signupTypedHere:';

const MARKED_FIELDS = [
  'fullName',
  'patientEmail',
  'patientEmailDraft',
  'patientCpf',
  'patientPhone',
];

/**
 * Marcas a limpar junto com as chaves do funil. Ficam só no `sessionStorage`:
 * levá-las para cookie/IDB destruiria a garantia de serem por aba.
 */
export const SIGNUP_TYPED_MARK_KEYS = MARKED_FIELDS.map((key) => MARK_PREFIX + key);

/** Registra que o paciente digitou esta chave nesta aba. */
export function markSignupFieldTyped(key) {
  try { sessionStorage.setItem(MARK_PREFIX + key, '1'); } catch {}
}

/** O paciente digitou esta chave nesta aba? */
export function isSignupFieldTypedHere(key) {
  try {
    return sessionStorage.getItem(MARK_PREFIX + key) === '1';
  } catch {
    return false;
  }
}

/** Valor da chave, e string vazia se não foi esta aba que a digitou. */
export function readSignupFieldTypedHere(key) {
  if (!isSignupFieldTypedHere(key)) return '';
  try {
    return String(sessionStorage.getItem(key) || '').trim();
  } catch {
    return '';
  }
}
